import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Fossil Sites';
moduleConfig.singleItemTitle = 'Fossil site';
moduleConfig.url = 'fossil-sites';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Enable Selected",
        value: "enabled"
    },
    {
        displayName: "Disable Selected",
        value: "disabled"
    }
];


export default moduleConfig;